var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 68,
    viewBox: "0 0 108 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.32837,
    y: 1,
    width: 97.3433,
    height: 66,
    rx: 4,
    stroke: "#F5F5F9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10449 22.6666H102.507",
    stroke: "#F5F5F9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10449 43H102.507",
    stroke: "#F5F5F9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8359 68L26.8359 -2.02656e-06",
    stroke: "#F5F5F9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6121 68L53.6121 -2.02656e-06",
    stroke: "#F5F5F9",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3882 68L80.3882 -2.02656e-06",
    stroke: "#F5F5F9",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49268 58.2299C5.80312 57.9172 18.8161 50.8046 25.2837 47.2874C31.4927 42.3372 44.0658 32.4368 44.6867 32.4368C45.3076 32.4368 66.2887 52.1073 72.627 56.6667L84.2688 38.6897L101.731 28.1379",
    stroke: "#A785FC",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88062 49.6322L24.1194 58.2299L45.0746 19.1495L65.6418 38.6897L83.8806 28.5288L104.06 16.8046",
    stroke: "#7163D0",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71642 52.5862C6.77557 52.5862 8.43284 50.907 8.43284 48.8506C8.43284 46.7941 6.77557 45.1149 4.71642 45.1149C2.65726 45.1149 1 46.7941 1 48.8506C1 50.907 2.65726 52.5862 4.71642 52.5862Z",
    fill: "#EFC916",
    stroke: "#7163D0",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1193 61.9654C26.1784 61.9654 27.8357 60.2862 27.8357 58.2298C27.8357 56.1733 26.1784 54.4941 24.1193 54.4941C22.0601 54.4941 20.4028 56.1733 20.4028 58.2298C20.4028 60.2862 22.0601 61.9654 24.1193 61.9654Z",
    fill: "#EFC916",
    stroke: "#7163D0",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0746 22.8851C47.1338 22.8851 48.7911 21.2059 48.7911 19.1495C48.7911 17.093 47.1338 15.4138 45.0746 15.4138C43.0155 15.4138 41.3582 17.093 41.3582 19.1495C41.3582 21.2059 43.0155 22.8851 45.0746 22.8851Z",
    fill: "#EFC916",
    stroke: "#7163D0",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.284 20.5401C105.343 20.5401 107 18.861 107 16.8045C107 14.748 105.343 13.0688 103.284 13.0688C101.224 13.0688 99.5671 14.748 99.5671 16.8045C99.5671 18.861 101.224 20.5401 103.284 20.5401Z",
    fill: "#EFC916",
    stroke: "#7163D0",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.507 31.4828C104.138 31.4828 105.448 30.1535 105.448 28.5287C105.448 26.9039 104.138 25.5747 102.507 25.5747C100.877 25.5747 99.5671 26.9039 99.5671 28.5287C99.5671 30.1535 100.877 31.4828 102.507 31.4828Z",
    fill: "#EFC916",
    stroke: "#A785FC",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6566 41.6436C86.2871 41.6436 87.5969 40.3144 87.5969 38.6896C87.5969 37.0648 86.2871 35.7356 84.6566 35.7356C83.0261 35.7356 81.7163 37.0648 81.7163 38.6896C81.7163 40.3144 83.0261 41.6436 84.6566 41.6436Z",
    fill: "#EFC916",
    stroke: "#A785FC",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0149 59.6207C74.6455 59.6207 75.9552 58.2915 75.9552 56.6667C75.9552 55.0419 74.6455 53.7126 73.0149 53.7126C71.3844 53.7126 70.0746 55.0419 70.0746 56.6667C70.0746 58.2915 71.3844 59.6207 73.0149 59.6207Z",
    fill: "#EFC916",
    stroke: "#A785FC",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2985 35.3908C45.929 35.3908 47.2388 34.0616 47.2388 32.4368C47.2388 30.812 45.929 29.4828 44.2985 29.4828C42.668 29.4828 41.3582 30.812 41.3582 32.4368C41.3582 34.0616 42.668 35.3908 44.2985 35.3908Z",
    fill: "#EFC916",
    stroke: "#A785FC",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49254 61.1839C7.12306 61.1839 8.43284 59.8547 8.43284 58.2299C8.43284 56.6051 7.12306 55.2759 5.49254 55.2759C3.86203 55.2759 2.55225 56.6051 2.55225 58.2299C2.55225 59.8547 3.86203 61.1839 5.49254 61.1839Z",
    fill: "#EFC916",
    stroke: "#A785FC",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8954 50.2413C26.5259 50.2413 27.8357 48.9121 27.8357 47.2873C27.8357 45.6625 26.5259 44.3333 24.8954 44.3333C23.2649 44.3333 21.9551 45.6625 21.9551 47.2873C21.9551 48.9121 23.2649 50.2413 24.8954 50.2413Z",
    fill: "#EFC916",
    stroke: "#A785FC",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2537 41.6437C67.3129 41.6437 68.9701 39.9645 68.9701 37.9081C68.9701 35.8516 67.3129 34.1724 65.2537 34.1724C63.1946 34.1724 61.5373 35.8516 61.5373 37.9081C61.5373 39.9645 63.1946 41.6437 65.2537 41.6437Z",
    fill: "#EFC916",
    stroke: "#7163D0",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.fbfc6ff2.svg";
export { ForwardRef as ReactComponent };